import { useTheme } from './use-theme';

/**
 * @param light - The light asset path
 * @param dark - The dark asset path
 * @returns The themed asset path
 */
export const useThemedAssetPath = (light: string, dark: string): string => {
  const { isDarkMode } = useTheme();
  return isDarkMode ? dark : light;
};
